package com.macrofocus.eflux.ui

import com.macrofocus.common.properties.MutableProperty
import mui.material.Box
import mui.material.Stack
import mui.material.StackDirection
import mui.system.responsive
import mui.system.sx
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import react.FC
import react.Props
import web.cssom.Position
import web.cssom.number

external interface TwoColumnsInfoProps : Props {
    var primaryInfo: CPComponent
    var secondaryInfo: CPComponent?
}

val TwoColumnsInfo = FC<TwoColumnsInfoProps> { props ->
//    val (selection, _) = props.dataLoader.selection.toState()

    Stack {
        direction = responsive(StackDirection.row)

        Box {
            sx {
                position = Position.relative
//                width = 50.pct
//                maxWidth = 50.pct
                flexGrow = number(1.0) // or width = 0.pct and flex = 1.0
            }
//            if(selection != null) {
                props.secondaryInfo?.nativeComponent()
//            }
        }

        Box {
            sx {
                position = Position.relative
//                width = 50.pct
//                maxWidth = 50.pct
                flexGrow = number(1.0) // or width = 0.pct and flex = 1.0
            }
//            if(selection != null) {
                props.primaryInfo.nativeComponent()
//            } else {
//                props.secondaryInfo.nativeComponent()
//            }
        }
    }
}

class CPTwoColumnsInfo constructor(secondary: MutableProperty<Boolean>, primaryInfo: CPComponent, secondaryInfo: CPComponent?) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> { props ->
        val (getSecondary, _) = useProperty(secondary)

        TwoColumnsInfo {
            this.primaryInfo = primaryInfo
            this.secondaryInfo = if(getSecondary) secondaryInfo else null
        }
    }
}